module.exports = __webpack_public_path__ + "static/tagline-img-5a454d68e82e69f24d96b95275d9accd.png";